import { getAppCache } from '@retail/core';
import { getGeorgeByteImage } from '@shared/image';
import { useProfileImage } from '@shared/profile';

const MY_USER_IMAGE_URL = 'my/images/user-image';

function loadUserImageBig(offlineKey: string): void {
    getGeorgeByteImage(`${MY_USER_IMAGE_URL}?variant=retina`, (data) => {
        const appCache = getAppCache();
        const appCacheKey = `userImage-${offlineKey}`;

        if (data) {
            useProfileImage.dispatchActions.setImageBigBase64(data);
            appCache.set(appCacheKey, data);
        } else {
            useProfileImage.dispatchActions.setImageBigBase64(undefined);
            appCache.remove(appCacheKey);
        }
    });
}

export function loadUserImage(offlineKey: string): void {
    getGeorgeByteImage(`${MY_USER_IMAGE_URL}?variant=retina`, (data) => {
        const appCache = getAppCache();
        const appCacheKey = `userImage-${offlineKey}`;

        if (data) {
            useProfileImage.dispatchActions.setImageBase64(data);
            appCache.set(appCacheKey, data);
            loadUserImageBig(offlineKey);
        } else {
            useProfileImage.dispatchActions.setImageBase64(undefined);
            useProfileImage.dispatchActions.setImageBigBase64(undefined);
            appCache.remove(appCacheKey);
        }
    });
}
